// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tcfe","questions":"styles_questions__3qVdB","footer":"styles_footer__2BSFH"};